import axios from "axios";


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});


export class BankConsilationFetchAPI {

    //Function to make the consiltation of the bank
    static async getConsilationBankReport(file, startDate, endDate, selectedColumn, token) {
        const res = await server(`/bank/consiliation`, {
            method: "post",
            data: {
                files: file,
                startDate, endDate,
                referencedColum: selectedColumn
            },
            headers: {
                "x-access-token": token,
                'Content-Type': 'multipart/form-data',
            }
        });
        return res
    }

    //Function to make the consolidation of the transacionts by lote 
    static async getConsilationLoteReport(data, token) {
        const res = await server(`/bank/consolidate-transactions`, {
            method: "post",
            data: data,
            headers: {
                "x-access-token": token,
            }
        });
        return res
    }


    //Function to make the consolidation of the transacionts by lote 
    static async getConsilationBankStatement(data, token) {
        const res = await server(`/bank/consolidate-batchs`, {
            method: "post",
            data: data,
            headers: {
                "x-access-token": token,
            }
        });
        return res
    }

    //Function to save the consilated transaction bank bactch 
    static async saveBankConciliationBatch(data, token) {
        const res = await server(`/consiliation/batch/save`, {
            method: "post",
            data: data,
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }


    //Function to save the consilated transaction bank bactch 
    static async saveBankConciliation(data, token) {
        const res = await server(`/bank/consiliation`, {
            method: "post",
            data: data,
            headers: {
                "x-access-token": token,
                'Content-Type': 'multipart/form-data',
            }
        })
        return res
    }



    //Function to get the bank conciliation batches 
    static async getBankConciliationBatches(token) {
        const res = await server(`/consiliation/batch`, {
            method: "get",
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

    //Function to get the bank conciliation history
    static async getBankConsiliationHistory(startDate, endDate, token) {
        const res = await server(`/consiliation/history?startDate=${startDate}&endDate=${endDate}`, {
            method: "get",
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

    //Function to get the bank statements templates 
    static async getBankStatementsTemplates(token, bankName, business_code) {
        let url = `/bankstatement/template/format?bank_name=${bankName}&business_code=${business_code}`

        //If the bank name is all we get all the templates
        if (bankName === "all") {
            url = `/bankstatement/template/format?business_code=${business_code}`
        }
        const res = await server(url, {
            method: "get",
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

    //Function to get the bank statements
    static async getBankStatements(token, business_code, min_date, max_date, status, bank) {
        let url = `/bankstatement?business_code=${business_code}`
        if (min_date) {
            url += `&min_date=${min_date}`
        }
        if (max_date) {
            url += `&max_date=${max_date}`
        }
        if (status) {
            url += `&status=${status}`
        }
        if (bank) {
            url += `&bank=${bank}`
        }
        const res = await server(`${url}`, {
            method: "get",
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

    //Function to save a bank statement 
    static async saveBankStatement(token, bankName, business_code, file, template_colums, bankStatementName, bankStatementTemplateId) {
        const res = await server(`/bankstatement`, {
            method: "post",
            data: {
                name: bankStatementName,
                bank_name: bankName,
                business_code,
                files: file,
                template_columns: template_colums, 
                bankStatementTemplateId: bankStatementTemplateId
            },
            headers: {
                "x-access-token": token,
                'Content-Type': 'multipart/form-data',
            }
        })
        return res
    }

    //Function to update a bank statement
    static async updateBankStatement(token, status, bankStatementId) {
        const res = await server(`/bankstatement`, {
            method: "put",
            data: {
                status,
                bankStatementId: bankStatementId
            },
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

    //Function to save a bank statement template 
    static async saveBankStatementTemplate(token, bankName, business_code, template, templateName) {
        const res = await server(`/bankstatement/template/format`,
            {
                method: "post",
                data: {
                    name: templateName,
                    bank_name: bankName,
                    business_code,
                    template
                },
                headers: {
                    "x-access-token": token,
                }
            })
        return res
    }

    //Function to remove a bank statement movement 
    static async removeBankStatementMovement(token, movementId, bankStatementId) {
        const res = await server(`/bankstatement/movement`, {
            method: "delete",
            data: {
                movementId,
                bankStatementId
            },
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

     //Function to get a bank statement movement details
     static async getBankStatementMovement(token, movementId, bankStatementId) {
        const res = await server(`/bankstatement/movement?bankStatementId=${bankStatementId}&bankStatementTransactionId=${movementId}`, {
            method: "get",
            headers: {
                "x-access-token": token,
            }
        })
        return res
    }

}